(function () {
  'use strict';

  var handle = window.TCB_PM_GUIDE_HANDLE;
  var jsonUrl = window.TCB_PM_GUIDES_URL;
  if (!handle || !jsonUrl) return;

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function assetUrl(name) {
    if (!name) return '';
    if (name.indexOf('http') === 0 || name.indexOf('//') === 0) return name;
    var base = window.TCB_PM_ASSET_BASE || '/cdn/shop/t/1/assets/';
    return base + name;
  }

  function blogUrl(slug) {
    var base = window.TCB_PM_BLOG_BASE || '/blogs/news/';
    return base + slug;
  }

  function renderHub(root, guide) {
    var checklist = root.querySelector('[data-pmg-checklist]');
    if (checklist && guide.checklist) {
      checklist.innerHTML = guide.checklist
        .map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        })
        .join('');
    }

    var proTip = root.querySelector('[data-pmg-pro-tip]');
    if (proTip && guide.proTip) proTip.textContent = guide.proTip;

    var tiles = root.querySelector('[data-pmg-part-tiles]');
    if (tiles && guide.partTiles) {
      tiles.innerHTML = guide.partTiles
        .map(function (tile) {
          var href = tile.guideHandle ? blogUrl(tile.guideHandle) : tile.shopUrl;
          return (
            '<a class="tcb-pmg-part-tile" href="' +
            escapeHtml(href) +
            '"><img src="' +
            escapeHtml(assetUrl(tile.image)) +
            '" alt="' +
            escapeHtml(tile.title) +
            '" loading="lazy"><span>' +
            escapeHtml(tile.title) +
            '</span><small>Shop part →</small></a>'
          );
        })
        .join('');
    }

    var steps = root.querySelector('[data-pmg-troubleshooting]');
    if (steps && guide.troubleshooting) {
      steps.innerHTML = guide.troubleshooting
        .map(function (item) {
          return (
            '<li><strong>' +
            escapeHtml(item.title) +
            '</strong><p>' +
            escapeHtml(item.text) +
            '</p></li>'
          );
        })
        .join('');
    }

    var note = root.querySelector('[data-pmg-troubleshoot-note]');
    if (note && guide.troubleshootNote) note.textContent = guide.troubleshootNote;

    var schedule = root.querySelector('[data-pmg-schedule]');
    if (schedule && guide.schedule) {
      schedule.innerHTML = guide.schedule
        .map(function (row) {
          function dot(on) {
            return on ? '<span class="tcb-pmg-dot" aria-label="Yes"></span>' : '';
          }
          return (
            '<tr><td>' +
            escapeHtml(row.task) +
            '</td><td>' +
            dot(row.afterUse) +
            '</td><td>' +
            dot(row.daily) +
            '</td><td>' +
            dot(row.weekly) +
            '</td><td>' +
            dot(row.monthly) +
            '</td><td>' +
            dot(row.quarterly) +
            '</td></tr>'
          );
        })
        .join('');
    }

    var safety = root.querySelector('[data-pmg-safety]');
    if (safety && guide.safetyTips) {
      safety.innerHTML = guide.safetyTips
        .map(function (tip) {
          return '<li>' + escapeHtml(tip) + '</li>';
        })
        .join('');
    }

    var faq = root.querySelector('[data-pmg-faq]');
    if (faq && guide.faq) {
      faq.innerHTML = guide.faq
        .map(function (item) {
          return (
            '<details><summary>' +
            escapeHtml(item.q) +
            '</summary><p>' +
            escapeHtml(item.a) +
            '</p></details>'
          );
        })
        .join('');
    }

    var sidebarSpecs = root.querySelector('[data-pmg-sidebar-specs]');
    if (sidebarSpecs && guide.specs) {
      sidebarSpecs.innerHTML = guide.specs
        .map(function (spec) {
          return (
            '<li><strong>' +
            escapeHtml(spec.label) +
            '</strong>' +
            escapeHtml(spec.value) +
            '</li>'
          );
        })
        .join('');
    }

    var relatedParts = root.querySelector('[data-pmg-related-parts]');
    if (relatedParts && guide.relatedParts) {
      relatedParts.innerHTML = guide.relatedParts
        .map(function (part) {
          var href = part.guideHandle ? blogUrl(part.guideHandle) : part.shopUrl;
          return (
            '<a class="tcb-pmg-related-part" href="' +
            escapeHtml(href) +
            '"><img src="' +
            escapeHtml(assetUrl(part.image)) +
            '" alt=""><div><strong>' +
            escapeHtml(part.title) +
            '</strong><span>Shop part →</span></div></a>'
          );
        })
        .join('');
    }

    var relatedArticles = root.querySelector('[data-pmg-related-articles]');
    if (relatedArticles && guide.relatedArticles) {
      relatedArticles.innerHTML = guide.relatedArticles
        .map(function (article) {
          return (
            '<a class="tcb-pmg-related-articles__card" href="' +
            escapeHtml(blogUrl(article.handle)) +
            '"><img src="' +
            escapeHtml(assetUrl(article.image)) +
            '" alt="" loading="lazy"><span>' +
            escapeHtml(article.title) +
            ' · ' +
            escapeHtml(String(article.readMinutes || 5)) +
            ' min read</span></a>'
          );
        })
        .join('');
    }
  }

  function renderPart(root, guide) {
    var fallbackImage = 'tcb-home-equipment-group.png';
    var partProductImg = root.querySelector('[data-pmg-part-product-image]');
    if (partProductImg && guide.tileImage) {
      partProductImg.src = assetUrl(guide.tileImage);
      partProductImg.alt = guide.partTitle || '';
    } else if (partProductImg) {
      partProductImg.src = assetUrl(fallbackImage);
    }
    var relatedImg = root.querySelector('[data-pmg-related-part-image]');
    if (relatedImg && guide.relatedImage) {
      relatedImg.src = assetUrl(guide.relatedImage);
      relatedImg.alt = guide.partTitle || '';
    } else if (relatedImg && guide.tileImage) {
      relatedImg.src = assetUrl(guide.tileImage);
      relatedImg.alt = guide.partTitle || '';
    }
    root.querySelectorAll('[data-pmg-part-shop]').forEach(function (el) {
      if (guide.partShopUrl) el.href = guide.partShopUrl;
    });
    var partProductTitle = root.querySelector('[data-pmg-part-product-title]');
    if (partProductTitle && guide.partTitle) partProductTitle.textContent = guide.partTitle;
  }

  function wireProductLinks(root, guide) {
    var machineUrl = '/products/' + (guide.machineHandle || '');
    root.querySelectorAll('[data-pmg-machine-link], [data-cta-machine-link]').forEach(function (el) {
      el.href = machineUrl;
    });
    var partsUrl = guide.partsUrl || '/collections/shop-all-parts?q=nilfisk+sc500';
    root.querySelectorAll('[data-pmg-parts-link], [data-cta-parts-link]').forEach(function (el) {
      el.href = partsUrl;
    });

    var short = guide.shortName || 'SC500';
    if (!guide.shortName && guide.machineName) {
      var match = String(guide.machineName).match(/\b([A-Z]{1,3}\d{2,4}[A-Z0-9]*)\b/i);
      if (match) short = match[1].toUpperCase();
    }
    var partsLabel = root.querySelector('[data-cta-parts-label]');
    var machineLabel = root.querySelector('[data-cta-machine-label]');
    if (partsLabel) partsLabel.textContent = 'Shop ' + short + ' Parts';
    if (machineLabel) machineLabel.textContent = 'Buy ' + short + ' Machine';
  }

  function resolveGuideHandle(data, handle, root) {
    if (!handle && root) {
      handle = root.getAttribute('data-pmg-guide-handle') || '';
    }
    if (!handle) return '';
    if (data[handle]) return handle;
    var short = String(handle).split('/').pop();
    if (data[short]) return short;
    return short;
  }

  fetch(jsonUrl)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      var guideHandle = resolveGuideHandle(data, handle, root);
      var guide = data[guideHandle];
      if (!guide) return;
      var root = document.querySelector('[data-tcb-parts-maintenance-guide]');
      if (!root) return;
      wireProductLinks(root, guide);
      if (guide.variant === 'hub') renderHub(root, guide);
      else renderPart(root, guide);
    })
    .catch(function () {
      /* ponytail: silent fail keeps static Liquid CTAs usable */
    });
})();
